import { FragmentStore } from '../runtime/stores/fragment'
import artifact from '$houdini/artifacts/ShippingDimensions'


// create the fragment store

export class ShippingDimensionsStore extends FragmentStore {
	constructor() {
		super({
			artifact,
			storeName: "ShippingDimensionsStore",
			variables: true,
			
		})
	}
}
